import { barkApi } from "@bark/bark-core";
import { getRecaptchaToken } from "@bark/bark-core/src/helpers/reCAPTCHA";


export const forgotPasswordRequest = async (email) => {
    const captchaToken = await getRecaptchaToken('reset_password');
    return new Promise(resolve => {
        barkApi(
            `reset-password`,
            {
                email,
                captchaToken,
                platform: 'web',
            },
            (res) => {
                resolve(res);
            },
            (error) => {
                if (error?.status === 422) {
                    resolve(false);
                } else {
                    console.error(error);
                    bugsnagClientNotify('forgotPasswordRequest not successful', error);
                    resolve(false);
                }
            },
            'POST'
        );
    })
};
